import {
	faCalendarAlt,
	faCodeBranch,
	faFingerprint,
	faGear,
	faIdBadge,
	faScrewdriverWrench,
} from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from 'i18next';
import { tss } from 'tss-react';

import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import FormatedDate from 'components/desktop/_general/FormatedDate/FormatedDate';
import LogoAnimation from 'components/desktop/_general/LogoAnimation/LogoAnimation';
import { GenericComponentVersionInfo } from 'types/VersionInfo/GenericComponentVersionInfo';

interface IProps {
	componentsVersionInfo: GenericComponentVersionInfo[];
}

const SystemInfoComponent = (props: IProps) => {
	const { classes, cx } = useStyles();

	const renderComponentVersion = (versionInfo: GenericComponentVersionInfo) => {
		return (
			<>
				<div className={cx('card col-5', classes.cardStyle)} key={versionInfo.buildId}>
					<div className="card-body">
						<h5 className={cx('card-title', classes.cardTitleStyle)}>
							<FontAwesomeIcon
								icon={faGear}
								style={{ marginRight: '6px' }}
							></FontAwesomeIcon>
							{versionInfo.componentName ? versionInfo.componentName : '---'}
							<RenderIf condition={versionInfo.buildDateUtc.getTime() === 0}>
								<> ({t('systemInfo:NOT_AVAILABLE')})</>
							</RenderIf>
						</h5>
					</div>
					<ul className="list-group list-group-flush" style={{ marginBottom: '1rem' }}>
						<li className={cx('list-group-item', classes.transparentBackground)}>
							<FontAwesomeIcon
								icon={faScrewdriverWrench}
								style={{ marginRight: '6px' }}
							></FontAwesomeIcon>
							<strong>{t('systemInfo:VERSION')}:</strong>{' '}
							{versionInfo.version ? versionInfo.version : '-----'}
						</li>
						<li
							className={cx('list-group-item', classes.transparentBackground)}
							style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}
						>
							<FontAwesomeIcon
								icon={faCalendarAlt}
								style={{ marginRight: '6px' }}
							></FontAwesomeIcon>
							<strong>{t('systemInfo:BUILD_DATE')}:</strong>{' '}
							{versionInfo.buildDateUtc ? (
								<FormatedDate date={versionInfo.buildDateUtc} />
							) : (
								'-----'
							)}
						</li>
						<li
							className={cx('list-group-item', classes.transparentBackground)}
							style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}
						>
							<FontAwesomeIcon
								icon={faIdBadge}
								style={{ marginRight: '6px' }}
							></FontAwesomeIcon>
							<strong>{t('systemInfo:BUILD_ID')}:</strong>{' '}
							{versionInfo.buildId ? versionInfo.buildId : '-----'}
						</li>
						<li
							className={cx('list-group-item', classes.transparentBackground)}
							style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}
						>
							<FontAwesomeIcon
								icon={faCodeBranch}
								style={{ marginRight: '6px' }}
							></FontAwesomeIcon>
							<strong>{t('systemInfo:BRANCH')}:</strong>{' '}
							{versionInfo.branch ? versionInfo.branch : '-----'}
						</li>
						<li
							className={cx('list-group-item', classes.transparentBackground)}
							style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}
						>
							<FontAwesomeIcon
								icon={faFingerprint}
								style={{ marginRight: '6px' }}
							></FontAwesomeIcon>
							<strong>{t('systemInfo:HASH')}:</strong>{' '}
							{versionInfo.hash ? versionInfo.hash : '-----'}
						</li>
					</ul>
				</div>
			</>
		);
	};

	return (
		<div className={classes.systemInfoContainer}>
			<LogoAnimation />
			<div className="row d-flex justify-content-center">
				{props.componentsVersionInfo.map((e: GenericComponentVersionInfo) => {
					return <>{renderComponentVersion(e)}</>;
				})}
			</div>
		</div>
	);
};

export const useStyles = tss.create({
	systemInfoContainer: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		flexWrap: 'wrap',
		width: '100%',
		height: '100%',
		background: "url('/img/background/Login_Background.jpg') no-repeat center center",
	},
	cardStyle: {
		margin: '1rem',
		backgroundColor: 'rgba(255, 255, 255, 0.8)',
	},
	cardTitleStyle: { fontWeight: 'bolder', color: '#276eb9' },
	transparentBackground: { backgroundColor: 'rgba(255, 255, 255, 0)' },
});

export default SystemInfoComponent;
